module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j2l15"))).then(() => parcelRequire('3a9aZ'));